import React from 'react';

class Option extends React.Component {
    render() {
        const { optionRenderer, item, onClick } = this.props;
        return (
            <div className="iwoca-select-option" onClick={onClick}>
                {optionRenderer ? optionRenderer(item) : item.label}
            </div>
        );
    }
}

export default Option;
